import { Observable } from 'rxjs/Observable';
import ajax from '@ui/services/api/ajax';

export interface CollectionApi {
  getCollections: () => Observable<any>;
  getCollectionsWithFocus: (storeId: number) => Observable<any>;
  getRequests: () => Observable<any>;
  removeCollectionById: (collectionId: string) => Observable<any>;
  editCollection: (collection: any) => Observable<any>;
  createCollection: (collection: any) => Observable<any>;
  uploadPhoto: (id: any, file: any) => Observable<any>;
  saveRequest: (request: any, collection: any[]) => Observable<any>;
}

export const collectionApi: CollectionApi = {
  getCollections: () => ajax.get({ url: 'collection/collections' }),
  getCollectionsWithFocus: (storeId: number) =>
    ajax.get({ url: `collection/collections/${storeId}` }),
  getRequests: () => ajax.get({ url: 'collection/requests' }),

  createCollection: (collection: any) => {
    if (collection.idLotus && typeof collection.idLotus === 'string') {
      collection.idLotus = collection.idLotus.trim();
    }
    if (collection.name && typeof collection.name === 'string') {
      collection.name = collection.name.trim();
    }
    if (collection.vendorCode && typeof collection.vendorCode === 'string') {
      collection.vendorCode = collection.vendorCode.trim();
    }
    return ajax.post({
      url: 'collection/create',
      body: { collection: JSON.stringify(collection) },
    })
  },

  uploadPhoto: (id: any, file: any) => {
    const formData = new FormData();
    formData.append('file', file.file);

    return ajax.post({ url: `collection/${id}/upload-photo`, body: formData });
  },

  removeCollectionById: collectionId =>
    ajax.post({ url: 'collection/remove', body: { collectionId } }),

  editCollection: (collection: any) => {
    if (collection.idLotus && typeof collection.idLotus === 'string') {
      collection.idLotus = collection.idLotus.trim();
    }
    if (collection.name && typeof collection.name === 'string') {
      collection.name = collection.name.trim();
    }
    if (collection.vendorCode && typeof collection.vendorCode === 'string') {
      collection.vendorCode = collection.vendorCode.trim();
    }
    return ajax.post({
      url: 'collection/edit',
      body: { collection: JSON.stringify(collection) },
    })
  },

  saveRequest: (request: any, collections: any[]) =>
    ajax.post({
      url: 'collection/save-request',
      body: {
        request: JSON.stringify(request),
        collections: JSON.stringify(collections),
      },
    }),
};



// WEBPACK FOOTER //
// ./src/api/collection/collection.ts